<template>
  <div>
    <empty-card :title="$t('instagram.hashtag-search')">
      <b-row class="justify-content-center align-items-center">
        <b-col
          md="4"
          sm="9"
        >
          <ok-text-input
            v-model="query"
            :label="$t('instagram.hashtag')"
          />
        </b-col>
        <b-col
          md="3"
          sm="3"
        >
          <b-button
            :disabled="loading"
            class="mr-50 mt-1"
            variant="primary"
            @click="fetchHashtags"
          >
            <b-spinner
              v-if="loading"
              small
              class="mr-50"
            />
            {{ $t('forms.search') }}
          </b-button>
        </b-col>

      </b-row>
    </empty-card>
    <error-alert
      v-if="error"
      :error="error"
    />
    <template v-if="!hideResults">
      <div
        class="mb-1 d-flex justify-content-center align-items-center"
        :class="hasResults?'bg-primary':'bg-warning'"
        style="min-height: 50px; border-radius: 5px"
      >
        <h4 class="p-0 text-white">
          {{ hasResults?$t('general.results'): $t('general.no-results') }}
        </h4>
      </div>
      <b-row v-if="hasResults">
        <b-col
          v-for="post in topPosts"
          :key="post.id"
          md="3"
        >
          <b-card
            no-body
            class="mb-3 media-card cursor-pointer"
            @click="goMedia(post.permalink)"
          >
            <div
              v-lazy:background-image="post.picture"
              class="bg-container"
              :style="{backgroundSize:post.hasThumbnail?'cover':'contain'}"
            />
            <b-card-body>
              <div class="media-card-title">
                <h6>{{ getTitle(post.caption) }}</h6>
              </div>
              <div class="d-flex justify-content-between media-card-desc">
                <span class="mr-50">
                  <i class="ml-10">{{ post.comments_count }}</i>
                  <FeatherIcon
                    size="20"
                    fill="#0D8BF1"
                    class="text-white"
                    icon="MessageCircleIcon"
                  />
                </span>
                <span>
                  <i class="ml-10">{{ post.like_count }}</i>
                  <FeatherIcon
                    size="20"
                    fill="#FB160A"
                    class="text-white"
                    icon="HeartIcon"
                  />
                </span>

              </div>
            </b-card-body>

          </b-card>
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import InstagramMediaApi from '@/api/instagram/media'
import { mapGetters } from 'vuex'
import {
  BButton, BSpinner, BRow, BCol, BCard, BCardBody,
} from 'bootstrap-vue'

export default {
  name: 'HashtagSearch',
  components: {
    ErrorAlert, OkTextInput, EmptyCard, BButton, BSpinner, BRow, BCol, BCard, BCardBody,
  },
  data() {
    return {
      loading: false,
      showResults: false,
      error: null,
      topPosts: [],
      recentPosts: [],
      query: '',
    }
  },
  computed: {
    ...mapGetters({
      currentPage: 'instagram/currentAccount',
    }),
    hideResults() {
      return !this.showResults || this.loading || this.error
    },
    hasResults() {
      return !this.hideResults && (this.topPosts.length || this.recentPosts.length)
    },
  },
  methods: {
    async fetchHashtags() {
      if (this.query === '') {
        this.$notifyError('ادخل الهاشتاغ من فضلك')
        return
      }
      this.loading = true
      await InstagramMediaApi.hashtagsSearch(this.query, this.currentPage.id).then(res => {
        if (res.error === 0) {
          this.showResults = true
          this.topPosts = res.data.topMedia
          this.recentPosts = res.data.recentMedia
        }
      }).catch(e => {
        this.error = e
      })
        .finally(() => {
          this.loading = false
        })
    },
    getTitle(title) {
      if (title.length > 25) return `${title.substring(0, 25)}..`
      return title
    },
    goMedia(link) {
      window.open(link, '_blank').focus()
    },
  },
}
</script>
<style lang="scss">
.media-card{
  .card-body {
    padding: 10px 0 0;
    .media-card-title{
      padding: 0 20px;
    }
    .media-card-desc{
      padding: 10px 20px 10px;
      border-top: 1px solid lavender;
      margin-top: 13px;;
    }
  }
}
.bg-container{
  height: 200px;
  background-position: center;
  width: 100%
}
</style>
